import React from 'react'
import { injectReducer } from 'store'
import reducer from './store'
import { useSelector } from 'react-redux'
injectReducer('dashboard', reducer)

export default function Home() {
    const user = useSelector(state => state.auth.user)
    return (
        <div>
            <div className="p-4 bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark md:p-6 xl:p-9">
                <div className="flex flex-col gap-3">
                    <div className="text-gray-900">
                        Welcome {user.first_name || 'User'} {user.last_name}
                    </div>
                </div>
            </div>
        </div>
    )
}
